import { inject as service } from '@ember/service';
import Controller from '@ember/controller';
import { action, computed } from '@ember/object';
import { readOnly } from '@ember/object/computed';
import { tracked } from '@glimmer/tracking';
import AuthService from 'cio/services/auth';
import CampaignModel from 'cio/models/campaign';
import NewsletterModel from 'cio/models/newsletter';

const DEFAULT_SORT = 'updated';

export default class BroadcastsListController extends Controller {
  @service auth!: AuthService;

  search = '';
  _search: string | null = null;
  sendToUnsubscribed: boolean | null = null;
  tagIds: string[] = [];
  page = 1;
  sort = DEFAULT_SORT;
  asc = false;
  state: string | null = null;
  @tracked subscriptionTopicId: string | null = null;
  @tracked objectTypeIds: string[] = [];

  @readOnly('model') broadcasts!: CampaignModel | NewsletterModel;

  @computed('asc', {
    get(this: BroadcastsListController) {
      return !this.asc;
    },

    set(this: BroadcastsListController, key, value) {
      this.set('asc', !value);
      return !!value;
    },
  })
  sortDescending!: boolean;

  setDefaultQueryParams() {
    this.setProperties({
      page: 1,
      sort: DEFAULT_SORT,
      asc: false,
      search: '',
      _search: '',
      sendToUnsubscribed: null,
      subscriptionTopicId: null,
      state: null,
    });
  }

  @action
  searchFor(search: string) {
    this.setProperties({
      page: 1,
      search,
    });
  }
}
